/**
 * Lesson Selection Policy
 *
 * Determines HOW the next lesson is chosen.
 * This does NOT affect in-lesson adaptivity.
 */

export const LessonSelectionPolicy = {
  /**
   * Confidence below which we force curriculum order
   */
  CURRICULUM_CONFIDENCE_THRESHOLD: 0.55,

  /**
   * Percentage of lessons completed before adaptive mode is allowed
   */
  ADAPTIVE_READINESS_RATIO: 0.35,

  /**
   * Resume window (ms)
   */
  RESUME_WINDOW_MS: 2 * 24 * 60 * 60 * 1000, // 2 days

  /**
   * Default selection mode
   */
  DEFAULT_MODE: "curriculum", // "curriculum" | "adaptive"
};
